import {Injectable} from '@angular/core';

@Injectable()
export class Payment {

    public id: string;
    public paymentDate: string;
    public paymentTime: string;
    public amountPaid: string;
    public cardNumber: string;
    public authCode: string;

    constructor(){}

}



// WEBPACK FOOTER //
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/shared/models/payment.ts